import React from "react";
import Popup from "../popups/popup";
import { connect } from "react-redux";
import ZipCode from "../lightListing/dropOff/zipCode";
import Offices from "../lightListing/dropOff/offices";
import PhoneNumber from "../lightListing/dropOff/phoneNumber";
import styled from "styled-components";
import Calendar from "../lightListing/dropOff/calendar";
import {MediumPrimaryButton} from "@worthy-npm/clarity";
import {acceptItemEstimation, generateOfficeDropOffShipment} from "../../actions/item";
import {bindActionCreators} from "redux";
import Loader from "../loaderAnimated";
import {hideTips} from "../../actions/tips";

const Container = styled.div`
    width: 100%;
    height: auto;
    display: flex;
`;

const AnimatedLoader = styled(Loader)`
    min-height: 200px;
    display: flex;
`;

const Congrats = styled.div`
    font-family: "Uncut Sans" !important;
    font-size: 15px !important;
    line-height: normal;
    width: 85%;
    margin: auto;

    b {
        font-weight: 700;
    }

    p {
        margin-top: 16px;
    }
    .tip {
        font-size: 14px !important;
        color: #999999;
    }
`;

class DropOffOfficesModalPopup extends Popup {
    constructor(props) {
        super(props);

        this.state = {
            step: "enterZipcode",
            offices: [],
            office: {},
            dateTime: null,
            apiError: null,
        };
    }

    static initPopup(props = {}) {
        Popup.initPopup.call(this, props);
    }

    _hide(manual=true, delay=250) {
        super._hide(manual, delay);
        this.props.hideTips();
    }

    isPhoneNumberRequired() {
        const { user } = this.props.ADO;
        return  !user.phone || /0{9}\d{1}/.test(user.phone) || user.phone_invalid;
    }

    title() {
        switch (this.state.step) {
            case "enterPhone":
                return "What is your phone number?";
            case "enterZipcode":
                return "Where are you located?";
            case "chooseOffice":
                return "When would you like to visit?";
            case "apiError":
                return "In-Person Appointment";
            case "appointmentCreating":
                return "In-Person Appointment";
            case "congratulations":
                return "Appointment has been set!";
            default:
                return "In-Person Appointment";
        }
    }

    phoneNumberTitle() {
        const { user } = this.props.ADO;
        if (user.phone_invalid && !user.phone.startsWith('000000000')) {
            return "Phone number is invalid. Please enter a valid phone number";
        }

        return "Please enter your phone number so we can confirm your appointment";
    }

    subtitle() {
        switch (this.state.step) {
            case "enterPhone":
                return this.phoneNumberTitle();
            case "enterZipcode":
                return "We will help you find the nearest office";
            case "chooseOffice":
                return "Choose an available appointment time below.";
            case "apiError":
                return "We have an API error";
            case "appointmentCreating":
                return "We are creating new appointment for you";
            case "congratulations":
                return "";
            default:
                return "Details";
        }
    }

    classNames() {
        return this.state.step;
    }

    setOffices(offices) {
        const {
            item: { enabled_drop_off_offices_circa_keys },
        } = this.props;

        if (offices.length === 0) {
            this.setState({ step: 'apiError', apiError: 'There are no offices for this zip code' });
            return ;
        }

        const  availableOffices = offices.filter((o)=>{
            return enabled_drop_off_offices_circa_keys.find((office_key) => { return office_key === o.key; } );
        });

        if (availableOffices.length === 0) {
            this.setState({ step: 'apiError', apiError: 'There are no open offices for this zip code' });
            return ;
        }

        const defaultOffice = availableOffices[0] ||  {};
        this.setState({ offices: availableOffices, office: defaultOffice, step: 'chooseOffice' });
    }

    setCurrentOffice(office) {
        this.setState({ office: office });
    }

    setDateTime(value) {
        this.setState({ dateTime: value });
    }

    findOffice(id) {
        return this.state.offices.find((o) => {
            return o.id === id;
        });
    }

    onError(error) {
        const msg =
            (error.data && error.data.message) || "Something went wrong.";
        this.setState({ step: "apiError", apiError: msg });
    }

    submitAppointment(stopAnimation, force = false) {
        stopAnimation();

        if(this.isPhoneNumberRequired() && !force){
            this.setState({ step: "enterPhone" });
            return;
        }

        this.setState({ step: "appointmentCreating" });

        const slectedOffice = this.findOffice(this.state.office.id);
        const itemId = this.props.item.id;
        const params = {
            dateTime: this.state.dateTime,
            officeId: this.state.office.id,
            officeKey: slectedOffice.key,
        };

        this.props
            .generateOfficeDropOffShipment(itemId, params)
            .then((data) => {
                stopAnimation();
                if (data.error) {
                    return this.onError(data.payload);
                }
                if (this.props.onSuccess) {
                    this.props.onSuccess(slectedOffice.name);
                }
                this.setState({ step: "congratulations" });
            })
            .catch((err) => this.onError(err));
    }

    isActiveSubmit() {
        return !!this.state.dateTime;
    }

    content() {
        const {
            item: { shipment },
        } = this.props;
        const office_drop_off_appointment =
            (shipment && shipment.office_drop_off_appointment) || null;

        return (
            <div className="schedule-shipment-custom-popup">
                {this.state.step === "enterPhone" && (
                    <PhoneNumber user={this.props.ADO.user} submitAppointment={this.submitAppointment.bind(this)} />
                )}

                {this.state.step === "enterZipcode" && (
                    <ZipCode setOffices={this.setOffices.bind(this)} />
                )}

                {this.state.step === "chooseOffice" && (
                    <>
                        <Container>
                            <Offices
                                offices={this.state.offices}
                                setCurrentOffice={this.setCurrentOffice.bind(
                                    this
                                )}
                            />
                            <Calendar
                                officeId={this.state.office.id}
                                setDateTime={this.setDateTime.bind(this)}
                            />
                        </Container>
                        <div className="offices-drop-off-wrapper">
                            <MediumPrimaryButton
                                text={this.isPhoneNumberRequired() ? "Next" : "Submit"}
                                click={this.submitAppointment.bind(this)}
                                disabled={!this.isActiveSubmit()}
                                overrideCSS={{
                                    marginTop: "40px",
                                    height: "47px",
                                    borderRadius: "16px",
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    fontFamily: 'inherit'
                                }}
                                overrideWrapperCSS={{}}
                            />
                        </div>
                    </>
                )}
                {this.state.step === "apiError" && <p>{this.state.apiError}</p>}

                {this.state.step === "appointmentCreating" && (
                    <Container>
                        <AnimatedLoader></AnimatedLoader>
                    </Container>
                )}

                {this.state.step === "congratulations" && (
                    <Congrats>
                        <p>
                            Your appointment is scheduled at
                            <b>
                                {" "}
                                {office_drop_off_appointment && office_drop_off_appointment.time}
                                {" "}
                            </b>
                            <br />
                            with an expert from our trusted partner CIRCA located at
                            <br />
                            <b>
                                {" "}
                                {office_drop_off_appointment && office_drop_off_appointment.office_address}
                                {" "}
                            </b>
                        </p>

                        <p className="tip">
                            We&apos;ve partnered with CIRCA to provide a convenient, secure way for you to hand deliver your jewelry to us.
                        </p>
                    </Congrats>
                )}
            </div>
        );
    }
}

DropOffOfficesModalPopup.defaultProps = {
    popupClassName: "popup-schedule-secure-shipment",
    single: true,
    modal: true,
};

const mapStateToProps = ({ Item, ADO, Experiments, Personalized }) => {
    return {
        item: Item,
        ADO,
        experiments: Experiments,
        P13N: Personalized,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { acceptItemEstimation, generateOfficeDropOffShipment, hideTips },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DropOffOfficesModalPopup);
